if (!App.isSSR) {
	$(document).ready(function() {
		$(".sideline-button").on("click", function(event) {
			event.preventDefault();
			$(this).toggleClass("active-sideline-button"); // eslint-disable-line no-invalid-this
			$(".fixed-sideline-navi").toggleClass("active-sideline-list");
		});

		$(".damentaschen-landingpage, .herrentaschen-landingpage").each(function() {
			const staticST = $(document).scrollTop();
			const headerHeight =
				$(this) // eslint-disable-line no-invalid-this
					.find(".header-image-box")
					.outerHeight() - 60;

			if (staticST >= headerHeight) {
				$(".sideline-button").css({
					position: "fixed",
					top: 110
				});
			} else {
				$(".sideline-button").css({
					position: "absolute",
					top: headerHeight + 30
				});
			}

			$(document).on("scroll", function() {
				const variableST = $(document).scrollTop();

				if (variableST >= headerHeight) {
					$(".sideline-button").css({
						position: "fixed",
						top: 110
					});
				} else {
					$(".sideline-button").css({
						position: "absolute",
						top: headerHeight + 30
					});
				}
			});
		});

		$(window).resize(function() {
			$(".damentaschen-landingpage, .herrentaschen-landingpage").each(function() {
				const staticST = $(document).scrollTop();
				const headerHeight =
					$(this) // eslint-disable-line no-invalid-this
						.find(".header-image-box")
						.outerHeight() - 60;

				if (staticST >= headerHeight) {
					$(".sideline-button").css({
						position: "fixed",
						top: 110
					});
				} else {
					$(".sideline-button").css({
						position: "absolute",
						top: headerHeight + 30
					});
				}

				$(document).on("scroll", function() {
					const variableST = $(document).scrollTop();

					if (variableST >= headerHeight) {
						$(".sideline-button").css({
							position: "fixed",
							top: 110
						});
					} else {
						$(".sideline-button").css({
							position: "absolute",
							top: headerHeight + 30
						});
					}
				});
			});
		});
	});
}
